import { paths } from "@utils/navigation";
import { generatePath } from "react-router-dom";
import { DRYBULK_CARGO_OPS_ROUTE_SEGMENTS } from "../constants";

const CARGO_OPS_BASE = `/${paths.drybulkCargoOperations.index}`;
const NOMINATION_DETAIL_PATTERN = `/${paths.vesselNomination.index}/${paths.vesselNomination.dryBulkDetails}`;

export const cargoOpsAddPath = (vesselCallId: string, vesselImo: string): string =>
  `${CARGO_OPS_BASE}/${paths.drybulkCargoOperations.add}?${new URLSearchParams({
    vesselCallId,
    vesselImo,
  }).toString()}`;

export const cargoOpsImportDeferredPath = (): string =>
  `${CARGO_OPS_BASE}/${paths.drybulkCargoOperations.importDeferred}`;

export const cargoOpsDetailPath = (operationId: string): string =>
  `${CARGO_OPS_BASE}/${operationId}`;

export const cargoOpsOperationPath = (row: { id: unknown; vesselCallId?: unknown }): string =>
  row.vesselCallId
    ? `/${paths.vesselCall.index}/${paths.vesselCall.vesselCallPreview}/${String(row.vesselCallId)}/${paths.vesselCall.operations.index}/${paths.vesselCall.operations.dryBulk}/${String(row.id)}`
    : cargoOpsDetailPath(String(row.id));

export const sequenceDetailsPath = (sequenceId: string): string =>
  `${DRYBULK_CARGO_OPS_ROUTE_SEGMENTS.sequence}/${sequenceId}`;

export const isInCargoOpsTree = (pathname: string): boolean =>
  pathname === CARGO_OPS_BASE || pathname.startsWith(`${CARGO_OPS_BASE}/`);

export const nominationDetailPath = (nominationId: string): string =>
  generatePath(NOMINATION_DETAIL_PATTERN, { id: nominationId });
